import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "currentColor",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M1.4 4.4h15.2v1.2H1.4V4.4Zm2.334 4.5h10.533v1.2H3.734V8.9Zm4.1 4.5h-.6v1.2h3.533v-1.2H7.834Z",
		clipRule: "evenodd"
	})
});
export default SvgFilter;
